import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const ProjectApi = () => {
  const axiosHandler = useAxios();

  const getAll = async ({
    page = 0,
    pageSize = 10,
    sort = "ALL",
    designerId = "",
    status = "",
  }) => {
    try {
      const res = await axiosHandler.get(
        `project/?page=${page}&pageSize=${pageSize}&sort=${sort}&designerId=${designerId}&status=${status}`
      );
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "Get Projects Api", error });
    }
  };

  const getStats = async ({ sort = "ALL", designerId = "", status = "" }) => {
    try {
      const res = await axiosHandler.get(
        `project/get-stats/?sort=${sort}&designerId=${designerId}&status=${status}`
      );
      return res;
    } catch (error) {
      LOGGER.error({ text: "Remove Project Api", error });
    }
  };

  const create = async (body) => {
    try {
      const res = await axiosHandler.post("project", body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Create Project Api", error });
    }
  };

  const update = async (body, id) => {
    try {
      
      const res = await axiosHandler.put(`project/${id}`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Update Project Api", error });
    }
  };

  const remove = async (id) => {
    try {
      const res = await axiosHandler.delete(`project/${id}`);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Remove Project Api", error });
    }
  };

  return {
    getAll,
    create,
    update,
    remove,
    getStats,
  };
};

export default ProjectApi;
